import React from 'react';
import { motion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  className?: string;
  as?: 'div' | 'li' | 'section' | 'article';
};
export function Reveal({
  children,
  delay = 0,
  y = 28,
  className,
  as = 'div'
}: RevealProps) {
  const MotionTag = motion[as] as typeof motion.div;
  return <MotionTag className={className} initial={{
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.7,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-342" data-mp="3gfxkopwl1ah2">
      {children}
    </MotionTag>;
}